<template>
    <!-- bottom-inset="54" - stejna konvence jako SkillPickerDialog.vue.
         full-height=false - zadani uzivatele 2026-08-27: popup se ma
         zkracovat podle poctu pokemonu (max 6 radku), ne byt vzdy 88vh. -->
    <ResponsiveDialog :value="value" @input="$emit('input', $event)" :max-width="420" :full-height="false" :bottom-inset="54" :header-title="$t('journey.pokemonPicker.title')" header-class="skin-window-header--picker" card-class="skin-card">
        <div class="picker-dialog-bg skin-window--picker">
            <div v-if="pokemons.length > 0" class="picker-toolbar">
                <v-menu offset-y :close-on-content-click="false" v-model="filterMenuOpen">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" :title="$t('journey.pokemonPicker.filterByType')">
                            <v-badge :value="selectedTypes.length > 0" :content="selectedTypes.length" color="primary" overlap>
                                <v-icon>mdi-filter-variant</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    <v-card class="picker-filter-menu">
                        <v-card-text>
                            <div class="picker-filter-menu-title">{{ $t('journey.pokemonPicker.filterByType') }}</div>
                            <v-chip-group v-model="selectedTypes" multiple column>
                                <v-chip v-for="type in availableTypes" :key="type.name" :value="type.name" small filter>
                                    {{ $t('common.typeNames.' + type.name) }}
                                </v-chip>
                            </v-chip-group>
                            <v-btn v-if="selectedTypes.length > 0" text small @click="selectedTypes = []">
                                {{ $t('journey.pokemonPicker.filterClear') }}
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-menu>

                <v-select
                    v-model="sortKey"
                    :items="sortOptions"
                    dense
                    hide-details
                    class="picker-toolbar-sort"
                />
            </div>
            <div class="picker-dialog-list-wrap">
                <template v-if="sortedPokemons.length > 0">
                    <div
                        class="picker-dialog-list"
                        :style="{height: listHeightPx + 'px'}"
                        @touchstart.passive="onTouchStart"
                        @touchend="onTouchEnd"
                    >
                        <div v-for="pokemon in pagedPokemons" :key="pokemon.id" class="picker-dialog-list-item">
                            <PokemonPickerCard
                                :pokemon="pokemon"
                                :allow-fainted="allowFainted"
                                :dungeon-available-skill-ids="dungeonAvailableSkillIds"
                                @click="choose(pokemon)"
                            />
                        </div>
                    </div>
                    <v-pagination
                        v-if="pageCount > 1"
                        v-model="page"
                        :length="pageCount"
                        :total-visible="5"
                        class="picker-dialog-pagination"
                    />
                </template>
                <div v-else-if="pokemons.length > 0" class="picker-dialog-empty">{{ $t('journey.pokemonPicker.emptyFiltered') }}</div>
                <div v-else class="picker-dialog-empty">{{ $t('journey.pokemonPicker.empty') }}</div>
            </div>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // Sdileny picker pro "zvol pokemona" i "Recall". `pokemons` uz prichazi
    // prefiltrovany od volajiciho (BattleScreen.vue vynecha aktualne
    // bojujiciho pokemona) - tady se nic dalsiho nefiltruje.
    //
    // Zadani uzivatele 2026-08-27 - az 6 (kompaktnich, PokemonPickerCard.vue)
    // radku se ma vejit na jednu obrazovku BEZ swipovani, mene radku popup
    // zkrati, vic nez 6 strankuje po skupinach 6 (swipe/v-pagination).
    // Obycejny raw touchstart/touchend (ne Swiper) - stejny osvedceny vzor
    // jako PvpHub.vue/Options.vue tab-swipe - puvodni Swiper implementace
    // pickeru mela dva bugy (kolecko mysi nescrollovalo, klik/tah se casto
    // vyhodnotil jako drag), proto byla puvodne nahrazena obycejnym seznamem.
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';
    import PokemonPickerCard from './PokemonPickerCard';

    const PAGE_SIZE = 6;
    // Zadani uzivatele 2026-08-27 - puvodnich 100px bylo na malych mobilech
    // zbytecne moc (obsah radku - PokemonPickerCard.vue - realne potrebuje
    // min), 6 radku se nevesli na obrazovku bez scrollu. ROW_HEIGHT_MOBILE/
    // _WIDE + breakpoint (500px) MUSI odpovidat .picker-dialog-list-item
    // v <style> nize - jde o stejnou hodnotu na dvou mistech (JS pro vysku
    // wrapperu, CSS pro vysku samotne polozky), pri zmene upravit obe.
    const ROW_HEIGHT_MOBILE = 76;
    const ROW_HEIGHT_WIDE = 92;
    const WIDE_BREAKPOINT = 500;
    const ROW_GAP = 8;

    export default {
        name: 'PokemonPickerDialog',
        components: {ResponsiveDialog, PokemonPickerCard},
        props: {
            value: {type: Boolean, default: false},
            pokemons: {type: Array, default: () => []},
            // Team Rocket zaseknuti bez ziveho pokemona - viz
            // PokemonPickerCard.vue, jen protazeno dal.
            allowFainted: {type: Boolean, default: false},
            // Dungeon "dnes jeste dostupne" skill pool - viz PokemonPickerCard.vue,
            // jen protazeno dal (zadani uzivatele 2026-08-27).
            dungeonAvailableSkillIds: {type: Array, default: null},
        },
        data() {
            return {
                page: 1,
                touchStartX: null,
                windowWidth: window.innerWidth,
                filterMenuOpen: false,
                // Nazvy typu (String[]) - zadani uzivatele 2026-08-28, lista
                // "filtr a razeni" nad seznamem. Prazdne pole = bez filtru.
                selectedTypes: [],
                sortKey: 'name',
            }
        },
        computed: {
            sortOptions() {
                return [
                    {value: 'name', text: this.$t('journey.pokemonPicker.sortName')},
                    {value: 'type', text: this.$t('journey.pokemonPicker.sortType')},
                    {value: 'freeExp', text: this.$t('journey.pokemonPicker.sortFreeExp')},
                ];
            },
            // Unikatni typy pritomne v (nefiltrovanem) seznamu - nabidka ve filtr menu.
            availableTypes() {
                const seen = new Map();
                this.pokemons.forEach((pokemon) => {
                    const type = pokemon.pokemonType.type;
                    if (!seen.has(type.name)) {
                        seen.set(type.name, type);
                    }
                });
                return Array.from(seen.values());
            },
            filteredPokemons() {
                if (this.selectedTypes.length === 0) {
                    return this.pokemons;
                }
                return this.pokemons.filter((pokemon) => this.selectedTypes.includes(pokemon.pokemonType.type.name));
            },
            sortedPokemons() {
                const list = this.filteredPokemons.slice();
                if (this.sortKey === 'name') {
                    list.sort((a, b) => (a.name || a.pokemonType.name).localeCompare(b.name || b.pokemonType.name));
                } else if (this.sortKey === 'type') {
                    list.sort((a, b) => a.pokemonType.type.name.localeCompare(b.pokemonType.type.name));
                } else if (this.sortKey === 'freeExp') {
                    // Sestupne - nejvic volnych expu (nejvic "co utratit") prvni.
                    list.sort((a, b) => (b.pokemonExperience ? b.pokemonExperience.freeExp : 0) - (a.pokemonExperience ? a.pokemonExperience.freeExp : 0));
                }
                return list;
            },
            pageCount() {
                return Math.max(1, Math.ceil(this.sortedPokemons.length / PAGE_SIZE));
            },
            pagedPokemons() {
                const page = Math.min(this.page, this.pageCount);
                const start = (page - 1) * PAGE_SIZE;
                return this.sortedPokemons.slice(start, start + PAGE_SIZE);
            },
            // Musi odpovidat breakpointu/hodnotam v ROW_HEIGHT_MOBILE/_WIDE vyse.
            rowHeight() {
                return this.windowWidth >= WIDE_BREAKPOINT ? ROW_HEIGHT_WIDE : ROW_HEIGHT_MOBILE;
            },
            // Kratsi seznam (<=6) zkrati i vysku popupu - vic nez 6 vzdy drzi
            // plnou 6-radkovou vysku (i kdyz posledni stranka ma mene polozek),
            // at swipe mezi strankami neposkakuje vyskou.
            listHeightPx() {
                const rows = this.sortedPokemons.length <= PAGE_SIZE ? Math.max(1, this.sortedPokemons.length) : PAGE_SIZE;
                return rows * this.rowHeight + (rows - 1) * ROW_GAP;
            },
        },
        created() {
            window.addEventListener('resize', this.onWindowResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onWindowResize);
        },
        watch: {
            // Novy seznam kandidatu (napr. po vyfaintovani/pouziti pokemona) -
            // stranka mimo rozsah by ukazala prazdno.
            pokemons() {
                if (this.page > this.pageCount) {
                    this.page = this.pageCount;
                }
            },
            value(isOpen) {
                if (isOpen) {
                    this.page = 1;
                    this.selectedTypes = [];
                    this.sortKey = 'name';
                }
            },
            selectedTypes() {
                this.page = 1;
            },
            sortKey() {
                this.page = 1;
            },
        },
        methods: {
            onWindowResize() {
                this.windowWidth = window.innerWidth;
            },
            choose(pokemon) {
                this.$emit('choose', pokemon);
                this.$emit('input', false);
            },
            // Stejny 40px prah/vzor jako onListTouchStart/onListTouchEnd v PvpHub.vue.
            onTouchStart(e) {
                this.touchStartX = e.changedTouches[0].clientX;
            },
            onTouchEnd(e) {
                const startX = this.touchStartX;
                this.touchStartX = null;
                if (startX === null || this.pageCount <= 1) {
                    return;
                }
                const deltaX = e.changedTouches[0].clientX - startX;
                if (Math.abs(deltaX) < 40) {
                    return;
                }
                this.page = deltaX < 0
                    ? Math.min(this.page + 1, this.pageCount)
                    : Math.max(this.page - 1, 1);
            },
        },
    }
</script>

<style scoped>
.picker-dialog-bg {
    flex: 1 1 auto;
    min-height: 0;
    /* pozadi ridi skin (public/skins/normal.css, .skin-window--picker) */
    display: flex;
    flex-direction: column;
}
.picker-toolbar {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 10px 12px 0;
}
.picker-toolbar-sort {
    max-width: 140px;
}
.picker-filter-menu {
    max-width: 260px;
}
.picker-filter-menu-title {
    font-size: 12px;
    font-weight: 700;
    opacity: 0.7;
    margin-bottom: 4px;
}
.picker-dialog-list-wrap {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    /* spodni padding je rezerva pro plovouci zaviraci krizek (ResponsiveDialog) */
    padding: 16px 12px var(--responsive-dialog-close-clearance) 12px;
}
.picker-dialog-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
/* 76px/92px musi odpovidat ROW_HEIGHT_MOBILE/_WIDE + WIDE_BREAKPOINT (500px) v <script> vyse. */
.picker-dialog-list-item {
    flex: none;
    height: 76px;
}
@media (min-width: 500px) {
    .picker-dialog-list-item {
        height: 92px;
    }
}
.picker-dialog-pagination {
    margin-top: 8px;
}
.picker-dialog-empty {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: rgba(0,0,0,0.7);
    padding-top: 40px;
}
</style>
